import React from 'react';
import { connect } from 'react-redux';
import * as actionTypes from '../.././../../redux/actionTypes';
import { getMaxDaysFromPackage } from '../../../../join-commute/helpers/vanHelpers';
import ChangeCommuteDaysConfirmation from '../../change-days/ChangeCommuteDaysConfirmation';
import ChangeCommuteDaysPopup from '../../change-days/ChangeCommuteDaysPopup';
import analyticsService from '../../../../shared/analytics/analytics-service';

function CommuteDaysSection(props) {
    const showCurrentDays = props.isSubscriptionActive && !props.isSubscriptionChanged && props.isDaysChanged
    function clickHandler() {
        props.openChangeMyCommuteDays();
        analyticsService.analyticsProcessEvent({
            "event": "click_generic",
            "context": {
                "event_action": "change my commute days"
            }
        });
    }
    return (
        <div className="commute-days" role='group'>
            {
                showCurrentDays && props.currentDays && props.currentDays.length &&
                <div className='current-commute-days'>
                    <div className='commute-days-heading current-days'>
                        {'Current commute days'}
                    </div>
                    <div className="days">
                        {props.currentDays.map(day => (
                            <div
                                key={day}
                                aria-label={day}
                                className="day-btn"
                                role='text'
                            >
                                {day.substr(0, 3)}
                            </div>))}
                    </div>
                    <div className="commute-seprator"></div>
                </div>
            }
            <div className="commute-days-heading">
               {
                 showCurrentDays && props.currentDays && props.currentDays.length ? "New commute days" : "Commute days"
               } 
            </div>
            <div className="days">
                {props.days.map(day => (
                    <div
                        key={day}
                        aria-label={day}
                        className="day-btn"
                        role='text'
                    >
                        {day.substr(0, 3)}
                    </div>))}
            </div>
            {props.startText && <div className='starting-date'>{props.startText}</div>}
            {props.endText && <div className='ending-date'>{props.endText}</div>}
            {props.lastRideDate && <div className='ending-date'>Last Ride Date: {props.lastRideDate}</div>}
            {props.endDate && <div className='ending-date'>Last Day of Subscription: {props.endDate}</div>}
            {!props.isSubscriptionChanged && !props.isNewSubscription && props.isSubscriptionActive && !props.isDaysChanged &&
                <div className="change-my-commute">
                    <button className="change-commute green-link-underline" onClick={clickHandler}>
                        Change my commute days
                    </button>
                    {props.showChangeCommuteDaysPopup && 
                        <ChangeCommuteDaysPopup 
                            saveCommuteDays={props.saveCommuteDays} 
                            plan={props.subscription.package} 
                            maxDays={getMaxDaysFromPackage(props.subscription.package)} 
                            isDriver={props.isDriver} 
                            vanpoolInfo={props.vanpoolInfo} 
                            close={() => props.updateShowChangeCommuteDaysPopup(false)} 
                        />}
                    {props.showChangeCommuteDaysConfirmation && 
                        <ChangeCommuteDaysConfirmation 
                            selectedDays={props.selectedDays} 
                            startDate={props.pendingChangeStartDate}
                            close={() => {
                                props.loadProfile();
                                props.updateShowChangeCommuteDaysConfirmation(false)
                            } } 
                        />}
                </div>
            }
        </div>
    );
}

  
  function mapDispatchToProps(dispatch) {
    return {
      loadProfile() {
        dispatch({ type: actionTypes.USER_PROFILE_LOADING, fromProfile:true });
        dispatch({ type: actionTypes.RESET_CHANGE_COMMUTE_DAYS });
      }
    };
  }
  
  export default
    connect(
      null,
      mapDispatchToProps
    )(CommuteDaysSection);
